import React from 'react';
import { Card, Typography, Space, Avatar, Skeleton, Divider } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWikipediaW } from '@fortawesome/free-brands-svg-icons';

const { Title, Text, Link } = Typography;
const { Meta } = Card;

function EpisodeCard ({ crimeData, showWiki, toggleWiki }) {
  const { title, link, time, description, city, wiki } = crimeData;
  const wikiButton = 
  wiki != undefined && wiki.length > 0
    ? <FontAwesomeIcon icon={faWikipediaW} onClick={toggleWiki} />
    : <DisconnectOutlined />;

  return (
    <Card 
      actions={[
        wikiButton,
        <DisconnectOutlined />,
        <DisconnectOutlined />,
      ]}
    >
      <Space direction='vertical'>
        <Title level={5}>
          <Link href={link} target="_blank">{title}</Link>
        </Title>
        <Text type='secondary'>{city}</Text>
        <Text>{description}</Text>
      </Space>
    </Card>
  )
}

function WikiCard ({ crimeData }) {
  const [ loading, setLoading ] = React.useState(true);
  const [ data, setData ] = React.useState({});

  const { wiki } = crimeData;
  const { displaytitle, thumbnail, originalimage, extract } = data;

  const pageTitle = wiki.slice(30);

  const fetchWiki = () => {
    fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${pageTitle}?redirect=true`)
    .then(jsonResponse => jsonResponse.json())
    .then(response => {
      setData(response);
      setLoading(false);  
    })
    .catch(error => {
      console.error(error);
      setLoading(false);
    })
  }

  React.useEffect(() => fetchWiki(), []);

  return (
    (!loading && <Card 
      loading={loading}
    >
      <Skeleton loading={loading} active>
        <Meta title={displaytitle} description={extract} />
      </Skeleton>
    </Card>)
  )
}

function Infopane ({ cardData, showCard, setShowCard }) {
  const [ showWiki, setShowWiki ] = React.useState(false);

  const node = React.useRef();

  const handleClickOutside = (e) => {
    if (!node.current.contains(e.target)) {
      setShowCard(false)
    }
  }

  React.useEffect(() => {
    if (showCard) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCard]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        position: "absolute",
        bottom: "20px",
        left: "20px",
        width: '44vw'
      }}
    >
      <div style={{ flex: 1 }}>
        <div ref={node}>
          <EpisodeCard
            crimeData={cardData}
            showWiki={showWiki}
            toggleWiki={() => setShowWiki(!showWiki)}
          />
        </div>
      </div>

      <div style={{ flex: 1 }}>
        {showWiki && <div ref={node}>
          <WikiCard crimeData={cardData} />
        </div>}
      </div>

    </div>
  )
};

export default Infopane;